import { createApi } from '@reduxjs/toolkit/query/react';
import  axiosInstance  from '../axiosinterceptor';
import { base_URL } from '../utils/api';

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
  async ({ url, method, data, params }) => {
    try {
      const result = await axiosInstance({
        url: url,
        method,
        data,
        params,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({ baseUrl: base_URL }),
  endpoints: (builder) => ({
    getData2: builder.query({
      query: () => {
        const hcplineIds = localStorage.getItem('last_hcp_line_id');
        const episodeHcpLineId = localStorage.getItem('episodeHcpLineId');
        //  const hcp_line_id = episodeHcpLineId ? episodeHcpLineId:hcplineIds
         const hcp_line_id = hcplineIds
        return {
          url: `/getEpisodeDataAcs`,
          method: 'GET',
          params: { hcp_line_id },
        };
      },

      transformResponse: (response) => {
        const sortAdditionalCodes = (list = []) => {
          return [...list].sort((a, b) => {
            const aZero = a.code?.startsWith("0");
            const bZero = b.code?.startsWith("0");

            if (aZero && !bZero) return 1;  
            if (!aZero && bZero) return -1;
            return 0;
          });
        };

        return {
          ...response,
          data: {
            ...response.data,
            additional_diagnoses: sortAdditionalCodes(
              response?.data?.additional_diagnoses ?? []
            )
          }
        };
      }
    }),
  })
});


export const {
  useLazyGetData2Query,
  useGetData2Query,
} = apiSlice;